import { OpenAPIRegistry, extendZodWithOpenApi } from '@asteasolutions/zod-to-openapi';
import { z } from 'zod';

// Extend Zod with OpenAPI methods (.openapi())
extendZodWithOpenApi(z);

// Create singleton registry for report schemas
export const reportSchemaRegistry = new OpenAPIRegistry();
